const assets = {
    images: {
        logo: require('./images/logo.PNG'),
    }
};

export default assets;